import { gql } from "@/admin/graphql.gen/gql.ts";

export const GET_REVENUE_INVOICES = gql(/* GraphQL */ `
    query GetRevenueInvoiceList(
        $limit: Int
        $orderField: InvoiceOrderFields
        $orderDir: OrderDirection
        $filters: [InvoiceFilter!]
    ) {
        admin_invoice_list(limit: $limit, orderField: $orderField, orderDir: $orderDir, filters: $filters) {
            items {
                created
                document_type
                type
                totals {
                    subtotal_resource_usage
                    total_before_tax
                }
            }
        }
    }
`);
